
























import settings from '@/settings'
import n from '@/utils/notifications'

export default {
    name: 'change_password_part'

    props: {
        token_uid:
            type: String,
            required: true
    }

    data: ()->
        password: ""
        password_confirm: ""

    methods:
        new_password: ()->
            self = @
            # console.log "NEW PASSWORD !"
            url = settings.change_password_url+@token_uid+"/"
            @$store.commit("logout")
            @$http.post(url, {"password":@password, "password_confirm":@password_confirm})
            .then (resp)->
                if resp.body.status == "Failed"
                    n.error("Mot de passe : ", resp.body.message)
                else
                    n.success_message(resp.body.message)
                    self.$router.push({name:"login"})
            return

    mounted: ()->
        # console.log "CHANGE : "+@token_uid
        @$store.commit("logout")
        @$http.get(settings.change_password_url+@token_uid+"/")
        .then (resp)->
            if resp.body.status == "Failed"
                n.error("Mot de passe : ", resp.body.message)
            else if resp.body.status == "OK"
                n.success_message(resp.body.message)
}
